import { IconButton } from '@bfe/moly';
import { CloseIcon, MenuIcon } from '@bfe/moly-icons';
import { replacePath } from '@web3/utils';
import { usePopoverState } from '../../../hooks';
import logoPng from '../images/logo.png';
import { h5NavTrack, panelStateStore } from './misc';
import { sidebarPanels } from './sidebars';

export type MobileHeaderProps = {};

export function MobileHeader(_props: MobileHeaderProps) {
  const drawerState = usePopoverState();
  const { panel } = panelStateStore.useStoreState();

  const panelContent = sidebarPanels[panel] || sidebarPanels.main;

  return (
    <>
      <a
        href={replacePath('/web3')}
        className="ltr:ml-4 rtl:mr-4"
        onClick={() => {
          h5NavTrack('Homepage');
        }}
      >
        <img src={logoPng} alt="bybit logo" className="h-[22px]" />
      </a>
      <div className="ltr:ml-auto rtl:mr-auto ltr:mr-4 rtl:ml-4">
        <IconButton
          onClick={() => {
            drawerState.show();
            h5NavTrack('More');
          }}
        >
          <MenuIcon />
        </IconButton>
      </div>

      {drawerState.domVisible && (
        <div
          className="fixed left-0 right-0 top-0 bottom-0 bg-[#1e1e1ebf] backdrop-blur-md transition-all "
          onTransitionEnd={drawerState.transitionEnd}
          onClick={drawerState.hide}
          style={{
            opacity: drawerState.visible ? 1 : 0,
          }}
        >
          <div
            className="w-[312px] absolute top-0 bottom-0 right-0 bg-[#101014] transition-all py-4 pl-4"
            onClick={(e) => e.stopPropagation()}
            style={{
              transform: `translateX(${drawerState.visible ? '0' : '100%'})`,
            }}
          >
            <div className="h-full overflow-auto pr-4">{panelContent}</div>
            <IconButton className="absolute right-4 top-4 " onClick={drawerState.hide}>
              <CloseIcon />
            </IconButton>
          </div>
        </div>
      )}
    </>
  );
}
